<template>


<v-container ref="ContainerEditor">

        <v-layout row wrap>
            <CoreEditor
            :title="titleHead"
            :widthCanvas="wCanvas"
            :heightCanvas="hCanvas"
            />
        </v-layout>

  </v-container>


</template>



<script>
import CoreEditor from '@/components/CoreEditor'
import axios from "axios";
import { mapState } from "vuex";
import router from "../router";



  export default {
    name: "editor",
    metaInfo: {
      title: 'Редактор',
      titleTemplate: '%s - Cardolini'
    },
    components: {
      CoreEditor
    },
    data: () => ({
        deff: ''
    }),
    mounted() {
    console.log("monted EDITOR ROOT");
    let arrInputParam = null;
    let routeParam = this.$route.params.nameItem;
    console.log("nameItem = ", routeParam);


    this.$nextTick(
      function() {
        console.log("nameItem = ", routeParam.split('-')[0]);

/*         switch (routeParam.split('-')[0]) {
          case 'p':
         arrInputParam = this.dataItemsEdit[0].items.filter(function(iEdit){
                return iEdit.itemN === routeParam;
        })
        arrInputParam = arrInputParam[0];
                 console.log("arrInputParam PRINT EDITOR = ", arrInputParam);
                 this.$store.commit("currentItem", arrInputParam);
            break;
          case 'w':
         arrInputParam = this.dataItemsEdit[1].items.filter(function(iEdit){
                return iEdit.itemN === routeParam;
        })
        arrInputParam = arrInputParam[0];
                 console.log("arrInputParam WEB EDITOR = ", arrInputParam);
                 this.$store.commit("currentItem", arrInputParam);
            break;

          default:
            break;
        } */

     // console.log("name Item =",arrInputParam);


      }.bind(this))



  },

    computed: {
          currentItem() {
            return this.$store.state.currentItem;
          },
          hCanvas() {
            return this.$store.state.hCanvas;
          },
          wCanvas() {
            return this.$store.state.wCanvas;
          },
          titleHead() {
            return this.$store.state.titleHead;
          },
          dataItemsEdit() {
            return this.$store.state.dataItemsEdit;
          },
          libBGTest() {
            return this.$store.state.libBGTest;
          },
  },
  methods: {

    goToPage: function(namePage) {
            router.push(namePage);
          console.log("gotoPage page EDITOR ROOT = ", namePage);
      },



  },
  }




</script>
